// notificationService.js
// Stores the antd notification API instance from App.useApp() so that
// non-component utilities (like apiRequest.js) can show context-aware
// notifications without triggering the static-function warning.

let notificationApi = null;

export const setNotificationApi = (api) => {
  notificationApi = api;
};

export const showErrorNotification = (message, description = '', duration = 4.5) => {
  if (notificationApi) {
    notificationApi.error({ message, description, duration, placement: 'topRight' });
  }
};

export const showSuccessNotification = (message, description = '', duration = 4.5) => {
  if (notificationApi) {
    notificationApi.success({ message, description, duration, placement: 'topRight' });
  }
};
